export enum LanguageCodes {
  EN = "en",
  AF = "af",
  SQ = "sq",
  AR = "ar",
  AZ = "az",
  BE = "be",
  EU = "eu",
  BG = "bg",
  BN = "bn",
  BHO = "bho",
  BS = "bs",
  CA = "ca",
  CS = "cs",
  CY = "cy",
  DA = "da",
  DE = "de",
  EL = "el",
  EN_GB = "en-gb",
  DOI = "doi",
  ES_ES = "es-es",
  ES = "es",
  ES_MX = "es-mx",
  ET = "et",
  FA = "fa",
  FI = "fi",
  FR = "fr",
  GL = "gl",
  KA = "ka",
  HE = "he",
  HI = "hi",
  GU = "gu",
  HR = "hr",
  HU = "hu",
  HY = "hy",
  ID = "id",
  IS = "is",
  GA = "ga",
  IT = "it",
  JA = "ja",
  JV = "jv",
  KK = "kk",
  KN = "kn",
  GOM = "gom",
  KO = "ko",
  KY = "ky",
  LT = "lt",
  LV = "lv",
  MI = "mi",
  MAI = "mai",
  MK = "mk",
  MT = "mt",
  MR = "mr",
  MS = "ms",
  MN = "mn",
  NE = "ne",
  NL = "nl",
  OR = "or",
  PS = "ps",
  NO = "no",
  PL = "pl",
  PT_BR = "pt-br",
  PT_PT = "pt-pt",
  PA = "pa",
  RO = "ro",
  RU = "ru",
  SA = "sa",
  SK = "sk",
  SD = "sd",
  SL = "sl",
  SR = "sr",
  SV = "sv",
  SW = "sw",
  TA = "ta",
  TH = "th",
  TL = "tl",
  TG = "tg",
  TR = "tr",
  TT = "tt",
  TE = "te",
  UK = "uk",
  UR = "ur",
  TK = "tk",
  VI = "vi",
  ZH_CN = "zh-cn",
  UZ = "uz",
  ZH_HK = "zh-hk",
  ZH_TW = "zh-tw",
  JA_KANA = "ja-kana",
  AM = "am",
  AS = "as",
  BA = "ba",
  BRX = "brx",
  SN = "sn",
  PRS = "prs",
  DV = "dv",
  FO = "fo",
  FJ = "fj",
  HT = "ht",
  HA = "ha",
  MWW = "mww",
  IG = "ig",
  IKT = "ikt",
  IU = "iu",
  KS = "ks",
  KM = "km",
  RW = "rw",
  TLH_LATN = "tlh-Latn",
  KU = "ku",
  LO = "lo",
  LN = "ln",
  DSB = "dsb",
  LUG = "lug",
  MG = "mg",
  ML = "ml",
  MY = "my",
  NYA = "nya",
  OTQ = "otq",
  RUN = "run",
  SM = "sm",
  ST = "st",
  NSO = "nso",
  TN = "tn",
  SI = "si",
  SO = "so",
  TY = "ty",
  BO = "bo",
  TI = "ti",
  TO = "to",
  HSB = "hsb",
  UG = "ug",
  XH = "xh",
  YO = "yo",
  YUA = "yua",
  ZU = "zu",
  LA = "la",
  OC = "oc",
  EO = "eo",
  PAP = "pap",
  CEB = "ceb",
  LB = "lb",
  MIN = "min",
  SU = "su",
  TS = "ts",
  NY = "ny",
  SZL = "szl",
  PAG = "pag",
  SS = "ss",
  SCN = "scn",
  BAN = "ban",
  LUS = "lus",
  ACE = "ace",
  OM = "om",
  LTG = "ltg",
  BEM = "bem",
  TW = "tw",
  LMO = "lmo",
  YI = "yi",
  QU = "qu",
  CKB = "ckb",
  // missing from wp
  WOO = "woo",
  AWA = "awa",
  BGC = "bgc",
  CMN = "cmn",
  JA_HIRA = "ja-hira",
  SR_ME = "sr-me",
  SAT = "sat",
  WUU = "wuu",
  YUE = "yue",
  RAJ = "raj",
  KOK = "kok",
  MWR = "mwr",
}
